export default __webpack_public_path__ + "static/media/mini_logo.850548dd.png";